<template>
  <section class="[ flex ]" style="padding: 0">
    <NavBar :items="items" show-labels class="[ pt-5 border-r border-gray-200 ]" />
    <RouterView class="[ flex-1 px-5 py-4 ]" />
  </section>
</template>
<script setup lang="ts">
import NavBar, { NavBarItem } from "@/components/ui/NavBar.vue";

definePage({
  meta: {
    title: "Integrations",
    icon: "settings-cog",
    scope: "Integration.Read",
  },
  redirect: "/integrations/hooks",
});

const items: NavBarItem[] = [
  {
    label: "Hooks",
    route: "/integrations/hooks",
  },
  {
    label: "External Services",
    route: "/integrations/services",
  },
  {
    label: "CRM",
    route: "/integrations/crm",
  },
  {
    label: "Products",
    route: "/integrations/products",
  },
  {
    label: "Search",
    route: "/integrations/search",
  },
  {
    label: "Scripts",
    route: "/integrations/scripts",
  },
  {
    label: "API Keys",
    route: "/integrations/api-keys",
  },
];
</script>
